<script lang="ts">
  import { Select } from "primevue";
  import Message from "@/ui/message/message.vue";
  import { useField } from "vee-validate";
  import { PropType } from "vue";

  // @ts-ignore
  Select.compatConfig = {
    MODE: 3,
  };

  export default {
    components: { Select, Message },
    compatConfig: {
      MODE: 3,
    },
    props: {
      name: {
        type: String,
        default: "",
      },
      classes: {
        type: Object as PropType<{ select: string; label: string }>,
        default: undefined,
      },
    },
    setup(props) {
      const { value: localValue, errorMessage } = useField(() => props.name);
      return {
        localValue,
        errorMessage,
        name: props.name,
      };
    },
  };
</script>

<template>
  <Select v-bind="$attrs" v-model="localValue" :name="name" :invalid="!!errorMessage" :class="['h-[40px]', classes?.select]">
    <template #value="slotProps">
      <slot name="value" :value="slotProps.value"></slot>
    </template>
  </Select>
</template>
